<template>
  <div v-if="item" class="help-center__content" @click="emit('click', $event)">
    <p v-if="contextLabel" class="context-label">{{ contextLabel }}</p>
    <div class="header" v-if="item?.title || item?.icon">
      <img v-if="item?.icon" :src="item?.icon" :alt="item.title" />
      <h2>{{ item?.title }}</h2>
    </div>
    <div v-for="(element, index) of item?.content" :key="element.title">
      <div class="form" v-if="type === 'tab_forms'">
        <FormContent :element="element" :index="index" />
      </div>
      <div v-else>
        <GlobalContent
          v-if="type === 'tab_integrations'"
          :element="element"
          :index="index"
          origin="integrations"
        />
        <GlobalContent
          v-else-if="isNestedHelpCenterScope(type)"
          :element="element"
          :index="index"
          origin="nested"
        />
        <GlobalContent v-else :element="element" :index="index" origin="global" />
      </div>
    </div>
  </div>
  <div v-else>Loading....</div>
</template>

<script setup lang="ts">
import { HelpCenterInformation } from "@/@types/entities/helpcenter";
import FormContent from "@/app/entities/components/helpCenter/Forms/content/index.vue";
import GlobalContent from "@/app/entities/components/helpCenter/Global/content/index.vue";
import { isNestedHelpCenterScope } from "@/app/entities/utils/helpCenter";

defineProps<{
  item: HelpCenterInformation | undefined;
  type: string;
  contextLabel?: string;
}>();

const emit = defineEmits<{
  click: [event: MouseEvent];
}>();
</script>


<style scoped lang="sass">
.help-center
  &__content
    .context-label
      color: #00000073
      font-size: 12px
      line-height: 20px
      margin: 0
    .header
      display: flex
      justify-content: center
      align-items: center
      gap: 8px
      padding-bottom: 14px
      h2
        color: $gray-9
        text-align: center
        line-height: 28px
      img
        width: 25px
        height: 25px
        object-fit: cover
    .form
      .content img:last-child
        padding-top: 15px
    h2
      font-size: 20px
      margin: 0
    .general
      img
        object-fit: cover
      p
        color: $gray-13
        
</style>
